import { __rest, __assign } from './../../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import { Icon } from '../Icon.js';

function createIconComponent(SvgComponent) {
    var IconComponent = function (_a) {
        var size = _a.size, ariaLabel = _a.ariaLabel, className = _a.className, svgClassName = _a.svgClassName, svgProps = __rest(_a, ["size", "ariaLabel", "className", "svgClassName"]);
        return (React__default.createElement(Icon, { className: className, size: size, ariaLabel: ariaLabel },
            React__default.createElement(SvgComponent, __assign({ className: svgClassName }, svgProps))));
    };
    return IconComponent;
}

export { createIconComponent };
//# sourceMappingURL=createIconComponent.js.map
